module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/dark/down-6b65062793cfac9f5397595e0eccb07c.png";